import React from "react";
import "./index.scss"; // Assurez-vous que le fichier CSS est bien lié
import iconM from "../../assets/iconM.png";
import StickyButton from "../StickyButton";
const Mission = () => {
  return (
    <div className="top-con">
      <section className=" mission container ">
        {/* Div en haut avec les titres */}

        <div className="top-content-m ">
          <h1 className="big-title-m">Mission</h1>
          <p className="text-title-m">
            Ensemble pour un avenir meilleur <br /> Chez Junior Fondation, nous
            croyons en un monde où chaque enfant et chaque communauté a la
            possibilité de vivre dans la dignité et de réaliser son potentiel.
          </p>
        </div>

        <div className="row mt-4 mar-b">
          <div className="col-lg-3 mb-3">
            <div className="card-m">
              <div className="card-header-m">
                <div className="card-title-m">Enfants scolarisés</div>
                <div className="icon-circle-m">
                  <img src={iconM} alt="Suivant" />
                </div>
              </div>
              <div className="card-body-m">
                <div className="number-m">50 000 +</div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 mb-3">
            <div className="card-m">
              <div className="card-header-m">
                <div className="card-title-m">Puits construits</div>
                <div className="icon-circle-m">
                  <img src={iconM} alt="Suivant" />
                </div>
              </div>
              <div className="card-body-m">
                <div className="number-m">300 +</div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 mb-3">
            <div className="card-m">
              <div className="card-header-m">
                <div className="card-title-m">Repas distribués</div>
                <div className="icon-circle-m">
                  <img src={iconM} alt="Suivant" />
                </div>
              </div>
              <div className="card-body-m">
                <div className="number-m">1M +</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="sticky">
        <StickyButton />
      </div>
    </div>
  );
};

export default Mission;
